<template>
  <v-dialog
    v-model="value"
    :persistent="true"
    width="800"
    content-class="add-to-stop-list-dialog"
    @close="close"
  >
    <v-card class="add-to-stop-list-dialog_inner">
      <loader v-if="loading" absolute />
      <div class="add-to-stop-list-dialog_title">
        Хотите добавить “{{ menuItem.name }}” в стоп-лист?
      </div>
      <div class="add-to-stop-list-dialog_source">
        <v-row>
          <v-col cols="12" md="4" offset-md="1">
            <div class="add-to-stop-list-dialog_image">
              <v-img
                v-if="menuItem.image"
                :lazy-src="menuItem.image"
                :src="menuItem.image"
              ></v-img>
              <div v-else class="no-img">
                <font-awesome-icon icon="utensils" />
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="7">
            <div class="add-to-stop-list-dialog_reason">
              <p>Выберетие причину для активации стоп-листа</p>
              <enum-value-select-field
                v-model="reason"
                label=""
                :enum-class="getReasonEnumClass()"
              />
            </div>
          </v-col>
        </v-row>
      </div>

      <v-card-actions class="add-to-stop-list-dialog_actions">
        <div class="add-to-stop-list-dialog_actions_buttons">
          <v-btn
            class="add-to-stop-list-dialog_btn add-to-stop-list-dialog_btn__cancel"
            large
            depressed
            @click="close"
          >
            Отмена
          </v-btn>
          <v-btn
            color="#ff005f"
            class="add-to-stop-list-dialog_btn add-to-stop-list-dialog_btn__confirm"
            depressed
            large
            :disabled="!isValid"
            @click="confirm"
          >
            <icon-stop />
            В стоп-лист
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import IconStop from '@/components/aside/icons/IconStop.vue'
  import Loader from '@/components/loader/Loader.vue'
  import EnumValueSelectField from '@/components/ui/crud/fields/EnumValueSelectField.vue'
  import StopListReason from '@/models/enums/StopListReason'

  export default {
    name: 'AddToStopListDialog',
    components: { EnumValueSelectField, Loader, IconStop },
    emits: ['confirm', 'close'],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      menuItem: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        reason: null,
      }
    },
    computed: {
      isValid () {
        return !!this.reason
      },
    },
    watch: {
      value (val) {
        if (val) {
          this.reason = null
        }
      },
    },
    methods: {
      getReasonEnumClass () {
        return StopListReason
      },
      close () {
        this.$emit('close')
        this.$emit('input', false)
      },
      confirm () {
        this.$emit('confirm', {
          menuItemId: this.menuItem.id,
          reason: this.reason,
        })
      },
    },
  }
</script>

<style scoped lang="less">
.add-to-stop-list-dialog {
  &_inner {
    padding: 30px 30px 20px 30px;
    border-radius: 10px;

    .media-sm({
      padding: 30px 20px 20px 20px;
    });
  }

  &_title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
  }

  &_source {
    margin-bottom: 40px;

    .media-sm({
      margin-bottom: 10px;
    });
  }

  &_image {
    border-radius: 10px;
    overflow: hidden;

    .no-img {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      font-size: 70px;
      min-height: 145px;
      color: #f4c99e;
    }
  }

  &_reason {
    padding-top: 10px;
    p {
      font-weight: 500;
      font-size: 16px;
      text-align: center;
      margin-bottom: 20px;
    }

    .media-sm({
      p {
        font-size: 14px;
        margin-bottom: 10px;
      }
    });
  }

  &_actions {
    display: flex;
    padding: 0 12%;

    &_buttons {
      flex-grow: 1;
      display: flex;
      align-items: center;
    }

    .media-sm({
      padding: 0;

      &_buttons {
        display: block;

        .add-to-stop-list-dialog_btn {
          display: block;
          width: 100%;
          margin: 0 0 15px 0;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    });
  }

  &_btn {
    flex-grow: 1;
    flex-basis: calc(50% - 40px);
    font-weight: 500;
    font-size: 20px;
    text-transform: none;
    margin: 0 10px;

    &__confirm {
      color: white;
      svg {
        height: 28px;
        width: 40px;
      }
    }
  }
}
</style>
